export enum ErrorCode {
  MaxUsagesExceeded = 'maxUsagesExceeded',
  Unknown = 'unknown'
}

export class AuthenticationError extends Error {
}

export class NotAuthorizedError extends Error {
}

export class CancelledError extends Error {
}

export class NotFoundError extends Error {
}

type FieldErrorsCollection = {[index:string]:string[]};

export class ValueError extends Error {
  public readonly fieldErrors:FieldErrorsCollection;
  public readonly errors:string[];

  constructor(message?: string, fieldErrors?:FieldErrorsCollection, errors?:string[]) {
    super(message);
    this.fieldErrors = fieldErrors || {};
    this.errors = errors || [];
  }
}

type ErrorListener = (message: string, err:any)=>void;

const _errorListeners: ErrorListener[] = [];

export function handleError(message: string, err?: any) {
  console.error(message, err);
  for(const listener of _errorListeners) {
    listener(message, err);
  }
}

export function addErrorListener(listener:ErrorListener) {
  _errorListeners.push(listener);
}

export function removeErrorListener(listener:ErrorListener) {
  const index = _errorListeners.indexOf(listener);
  if(index >= 0) {
    _errorListeners.splice(index, 1);
  }
}